import { Icon } from '@ihsm/ui-shared';
import React from 'react';
import background from '../assets/background.svg';
import './AuthPage.scss';

const AuthPage: React.FC = ({ children }) => (
  <div
    className="auth-page"
    style={{ backgroundImage: `url(${background})`, backgroundSize: 'cover' }}
  >
    <div className="logo-wrapper">
      <Icon
        source="SPLogo"
        svgStyle={{
          width: '140px',
          height: '60px',
        }}
      />
    </div>
    <div className="auth-content">{children}</div>
  </div>
);

export default AuthPage;
